/**
 * Generates unique ID for given prefix using cryptographically secure random values.
 * @param {string} prefix Prefix for generated ID
 * @returns {string} A unique ID string
 */
export function getUniqueIdWithPrefix(prefix: string | undefined): string {
  // Use crypto.getRandomValues for better randomness
  const array = new Uint32Array(2);
  crypto.getRandomValues(array);
  const result = Array.from(array, (num) => num.toString(16).padStart(8, '0')).join('');

  if (!prefix) {
    return result;
  }

  return `${prefix}${result}`;
}
